"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Devices API
 * Device management service for Envoy IoT devices
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListDevicesProductEnum = exports.StatusApi = exports.StatusApiFactory = exports.StatusApiFp = exports.StatusApiAxiosParamCreator = exports.EnrollmentApi = exports.EnrollmentApiFactory = exports.EnrollmentApiFp = exports.EnrollmentApiAxiosParamCreator = exports.ErrorResponseErrorCodeEnum = exports.EnrollDeviceRequestProductEnum = exports.DeviceStatusResponseConnectionStatusEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
exports.DeviceStatusResponseConnectionStatusEnum = {
    Connected: 'CONNECTED',
    Disconnected: 'DISCONNECTED'
};
exports.EnrollDeviceRequestProductEnum = {
    Visitors: 'visitors',
    Rooms: 'rooms',
    Screens: 'screens',
    Deliveries: 'deliveries'
};
exports.ErrorResponseErrorCodeEnum = {
    InvalidToken: 'invalid_token',
    ExpiredToken: 'expired_token',
    InvalidProduct: 'invalid_product',
    CrossCompanyConflict: 'cross_company_conflict',
    ValidationServiceUnavailable: 'validation_service_unavailable',
    IotServiceUnavailable: 'iot_service_unavailable',
    IotConsistencyError: 'iot_consistency_error',
    IotOperationFailed: 'iot_operation_failed',
    RateLimitExceeded: 'rate_limit_exceeded',
    AttributeValidationFailed: 'attribute_validation_failed',
    AwsIotLimitExceeded: 'aws_iot_limit_exceeded',
    DeviceNotFound: 'device_not_found',
    LocationNotFound: 'location_not_found',
    MissingAuthorization: 'missing_authorization',
    MalformedUpstreamResponse: 'malformed_upstream_response',
    CompanyBillingInactive: 'company_billing_inactive',
    LocationInactive: 'location_inactive',
    UpstreamForceUpgrade: 'upstream_force_upgrade',
    DeviceNotAssignedToRoom: 'device_not_assigned_to_room',
    InternalError: 'internal_error',
    UnexpectedError: 'unexpected_error'
};
/**
 * EnrollmentApi - axios parameter creator
 */
var EnrollmentApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Registers a device with the Devices service and returns AWS IoT credentials. - First enrollment: Creates device record and AWS IoT Thing - Re-enrollment: Updates last_enrolled_at and issues fresh IoT JWT
         * @summary Enroll or re-enroll an IoT device
         * @param {EnrollDeviceRequest} enrollDeviceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollDevice: function (enrollDeviceRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([enrollDeviceRequest_1], args_1, true), void 0, function (enrollDeviceRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'enrollDeviceRequest' is not null or undefined
                            (0, common_1.assertParamExists)('enrollDevice', 'enrollDeviceRequest', enrollDeviceRequest);
                            localVarPath = "/a/devices/v1/enroll";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearerAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearerAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            localVarHeaderParameter['Accept'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(enrollDeviceRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.EnrollmentApiAxiosParamCreator = EnrollmentApiAxiosParamCreator;
/**
 * EnrollmentApi - functional programming interface
 */
var EnrollmentApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.EnrollmentApiAxiosParamCreator)(configuration);
    return {
        /**
         * Registers a device with the Devices service and returns AWS IoT credentials. - First enrollment: Creates device record and AWS IoT Thing - Re-enrollment: Updates last_enrolled_at and issues fresh IoT JWT
         * @summary Enroll or re-enroll an IoT device
         * @param {EnrollDeviceRequest} enrollDeviceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollDevice: function (enrollDeviceRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.enrollDevice(enrollDeviceRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EnrollmentApi.enrollDevice']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.EnrollmentApiFp = EnrollmentApiFp;
/**
 * EnrollmentApi - factory interface
 */
var EnrollmentApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.EnrollmentApiFp)(configuration);
    return {
        /**
         * Registers a device with the Devices service and returns AWS IoT credentials. - First enrollment: Creates device record and AWS IoT Thing - Re-enrollment: Updates last_enrolled_at and issues fresh IoT JWT
         * @summary Enroll or re-enroll an IoT device
         * @param {EnrollmentApiEnrollDeviceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollDevice: function (requestParameters, options) {
            return localVarFp.enrollDevice(requestParameters.enrollDeviceRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.EnrollmentApiFactory = EnrollmentApiFactory;
/**
 * EnrollmentApi - object-oriented interface
 */
var EnrollmentApi = /** @class */ (function (_super) {
    __extends(EnrollmentApi, _super);
    function EnrollmentApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Registers a device with the Devices service and returns AWS IoT credentials. - First enrollment: Creates device record and AWS IoT Thing - Re-enrollment: Updates last_enrolled_at and issues fresh IoT JWT
     * @summary Enroll or re-enroll an IoT device
     * @param {EnrollmentApiEnrollDeviceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    EnrollmentApi.prototype.enrollDevice = function (requestParameters, options) {
        var _this = this;
        return (0, exports.EnrollmentApiFp)(this.configuration).enrollDevice(requestParameters.enrollDeviceRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EnrollmentApi;
}(base_1.BaseAPI));
exports.EnrollmentApi = EnrollmentApi;
/**
 * StatusApi - axios parameter creator
 */
var StatusApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get device status and metadata
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevice: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getDevice', 'id', id);
                    localVarPath = "/a/devices/v1/devices/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication employeeAuth required
                    localVarHeaderParameter['Accept'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary List devices for a location
         * @param {string} locationId
         * @param {ListDevicesProductEnum} [product]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDevices: function (locationId_1, product_1, limit_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([locationId_1, product_1, limit_1], args_1, true), void 0, function (locationId, product, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'locationId' is not null or undefined
                    (0, common_1.assertParamExists)('listDevices', 'locationId', locationId);
                    localVarPath = "/a/devices/v1/devices";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication employeeAuth required
                    if (locationId !== undefined) {
                        localVarQueryParameter['location_id'] = locationId;
                    }
                    if (product !== undefined) {
                        localVarQueryParameter['product'] = product;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    localVarHeaderParameter['Accept'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.StatusApiAxiosParamCreator = StatusApiAxiosParamCreator;
/**
 * StatusApi - functional programming interface
 */
var StatusApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.StatusApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get device status and metadata
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevice: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDevice(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StatusApi.getDevice']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary List devices for a location
         * @param {string} locationId
         * @param {ListDevicesProductEnum} [product]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDevices: function (locationId, product, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listDevices(locationId, product, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StatusApi.listDevices']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.StatusApiFp = StatusApiFp;
/**
 * StatusApi - factory interface
 */
var StatusApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.StatusApiFp)(configuration);
    return {
        /**
         *
         * @summary Get device status and metadata
         * @param {StatusApiGetDeviceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevice: function (requestParameters, options) {
            return localVarFp.getDevice(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List devices for a location
         * @param {StatusApiListDevicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDevices: function (requestParameters, options) {
            return localVarFp.listDevices(requestParameters.locationId, requestParameters.product, requestParameters.limit, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.StatusApiFactory = StatusApiFactory;
/**
 * StatusApi - object-oriented interface
 */
var StatusApi = /** @class */ (function (_super) {
    __extends(StatusApi, _super);
    function StatusApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get device status and metadata
     * @param {StatusApiGetDeviceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    StatusApi.prototype.getDevice = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StatusApiFp)(this.configuration).getDevice(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List devices for a location
     * @param {StatusApiListDevicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    StatusApi.prototype.listDevices = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StatusApiFp)(this.configuration).listDevices(requestParameters.locationId, requestParameters.product, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return StatusApi;
}(base_1.BaseAPI));
exports.StatusApi = StatusApi;
exports.ListDevicesProductEnum = {
    Visitors: 'visitors',
    Rooms: 'rooms',
    Screens: 'screens',
    Deliveries: 'deliveries'
};
